import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/page-image/jsjlr/banner.png';
const _hoisted_1 = {
  class: "jsjlr-page"
};
const _hoisted_2 = {
  class: "content-wrapper"
};
const _hoisted_3 = {
  class: "section"
};
const _hoisted_4 = {
  class: "intro-content"
};
const _hoisted_5 = {
  class: "section"
};
const _hoisted_6 = {
  class: "photos-container"
};
const _hoisted_7 = {
  class: "scroll-container"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
  class: "photo-title"
};
const _hoisted_10 = {
  class: "photo-leader"
};
const _hoisted_11 = {
  key: 1,
  class: "no-data"
};
import { ref, onMounted } from 'vue';
import { getTechnicalManagerInfo } from '@/api/mentor';
// 接口返回的数据
export default /*@__PURE__*/_defineComponent({
  __name: 'Jsjlr',
  setup(__props) {
    const managerInfo = ref(null);
    // 获取技术经理人信息
    const fetchManagerInfo = async () => {
      try {
        const res = await getTechnicalManagerInfo();
        managerInfo.value = res.data;
      } catch (error) {
        console.error('获取技术经理人信息失败：', error);
      }
    };
    onMounted(() => {
      fetchManagerInfo();
    });
    return (_ctx, _cache) => {
      const _component_SectionTitle = _resolveComponent("SectionTitle");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "技术经理人",
        class: "banner"
      })], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SectionTitle, {
        title: "简介",
        showMore: false
      }), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString(managerInfo.value?.description || '加载中...'), 1)])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_SectionTitle, {
        title: "现场照片",
        showMore: false
      }), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [managerInfo.value?.imageList && managerInfo.value.imageList.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(Math.ceil(managerInfo.value.imageList.length / 2), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "photo-row",
          key: index
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managerInfo.value.imageList.slice(index * 2, index * 2 + 2), photo => {
          return _openBlock(), _createElementBlock("div", {
            class: "photo-card",
            key: photo.id
          }, [_createElementVNode("img", {
            src: photo.url,
            alt: photo.title,
            class: "photo-img"
          }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString(photo.title), 1), _createElementVNode("div", _hoisted_10, "项目负责人：" + _toDisplayString(photo.label), 1)]);
        }), 128))]);
      }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_11, "暂无照片"))])])])]), _createVNode(_component_Footer)]);
    };
  }
});